export default __webpack_public_path__ + "static/media/60mesh.c5d41045.png";